var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import TrsTool from "./TrsTool.vue";
import { Services } from "../services";
import { withPrefix } from "@/utils/redirect";
import { computed, ref, watch } from "vue";
import { getRedirectOnImportPath } from "../redirectPath";
import LoadingSpan from "@/components/LoadingSpan.vue";
import TrsServerSelection from "./TrsServerSelection.vue";
import { useRouter } from "vue-router/composables";
import { BCard } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TrsSearch',
    setup(__props) {
        const fields = [
            { key: "name", label: "Name" },
            { key: "description", label: "Description" },
            { key: "organization", label: "Organization" },
        ];
        const query = ref("");
        const results = ref([]);
        const trsServer = ref("");
        const loading = ref(false);
        const importing = ref(false);
        const trsSelection = ref(null);
        const errorMessage = ref(null);
        const hasErrorMessage = computed(() => {
            return errorMessage.value != null;
        });
        const itemsComputed = computed(() => {
            return computeItems(results.value);
        });
        const searchHelp = computed(() => {
            return "Search by workflow description. Tags (key:value) can be used to also search by metadata - for instance name:example. Available tags include organization and name.";
        });
        const services = new Services();
        watch(query, () => __awaiter(this, void 0, void 0, function* () {
            if (query.value == "") {
                results.value = [];
            }
            else {
                loading.value = true;
                try {
                    const response = yield axios.get(withPrefix(`/api/trs_search?query=${query.value}&trs_server=${trsServer.value}`));
                    results.value = response.data;
                }
                catch (e) {
                    errorMessage.value = e;
                }
                loading.value = false;
            }
        }));
        function onTrsSelection(selection) {
            trsSelection.value = selection;
            trsServer.value = selection.id;
            query.value = "";
        }
        function onTrsSelectionError(message) {
            errorMessage.value = message;
        }
        function showRowDetails(row, index, e) {
            var _a;
            if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.nodeName) !== "A") {
                row._showDetails = !row._showDetails;
            }
        }
        function computeItems(items) {
            return items.map((item) => {
                return {
                    id: item.id,
                    name: item.name,
                    description: item.description,
                    data: item,
                    _showDetails: false,
                };
            });
        }
        const router = useRouter();
        function importVersion(trsId, toolIdToImport, version, isRunFormRedirect = false) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!trsId || !toolIdToImport) {
                    errorMessage.value = "Import Failed. Unknown Id";
                    return;
                }
                importing.value = true;
                errorMessage.value = null;
                try {
                    const response = yield services.importTrsTool(trsId, toolIdToImport, version);
                    const path = getRedirectOnImportPath(response, isRunFormRedirect);
                    router.push(path);
                }
                catch (e) {
                    errorMessage.value = e || "Import failed for an unknown reason.";
                }
                importing.value = false;
            });
        }
        return { __sfc: true, fields, query, results, trsServer, loading, importing, trsSelection, errorMessage, hasErrorMessage, itemsComputed, searchHelp, services, onTrsSelection, onTrsSelectionError, showRowDetails, computeItems, router, importVersion, TrsTool, LoadingSpan, TrsServerSelection, BCard };
    }
});
